// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Hosts.proto

/* eslint-disable */
import Long from "long";
import type { CallContext, CallOptions } from "nice-grpc-common";
import {
  ArchiveHostRequest,
  ArchiveHostResponse,
  GetHostsRequest,
  GetHostsResponse,
  GetHostStatsRequest,
  GetHostStatsResponse,
  GetSecretKeyRequest,
  GetSecretKeyResponse,
  RegisterHostRequest,
  RegisterHostResponse,
  UpdateHostRequest,
  UpdateHostResponse,
} from "./Models/HostModels";

export const protobufPackage = "daisi.protos.v1";

export type HostsProtoDefinition = typeof HostsProtoDefinition;
export const HostsProtoDefinition = {
  name: "HostsProto",
  fullName: "daisi.protos.v1.HostsProto",
  methods: {
    getHosts: {
      name: "GetHosts",
      requestType: GetHostsRequest,
      requestStream: false,
      responseType: GetHostsResponse,
      responseStream: false,
      options: {},
    },
    register: {
      name: "Register",
      requestType: RegisterHostRequest,
      requestStream: false,
      responseType: RegisterHostResponse,
      responseStream: false,
      options: {},
    },
    update: {
      name: "Update",
      requestType: UpdateHostRequest,
      requestStream: false,
      responseType: UpdateHostResponse,
      responseStream: false,
      options: {},
    },
    getSecretKey: {
      name: "GetSecretKey",
      requestType: GetSecretKeyRequest,
      requestStream: false,
      responseType: GetSecretKeyResponse,
      responseStream: false,
      options: {},
    },
    archive: {
      name: "Archive",
      requestType: ArchiveHostRequest,
      requestStream: false,
      responseType: ArchiveHostResponse,
      responseStream: false,
      options: {},
    },
    getHostStats: {
      name: "GetHostStats",
      requestType: GetHostStatsRequest,
      requestStream: false,
      responseType: GetHostStatsResponse,
      responseStream: false,
      options: {},
    },
  },
} as const;

export interface HostsProtoServiceImplementation<CallContextExt = {}> {
  getHosts(request: GetHostsRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetHostsResponse>>;
  register(
    request: RegisterHostRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<RegisterHostResponse>>;
  update(request: UpdateHostRequest, context: CallContext & CallContextExt): Promise<DeepPartial<UpdateHostResponse>>;
  getSecretKey(
    request: GetSecretKeyRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetSecretKeyResponse>>;
  archive(
    request: ArchiveHostRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ArchiveHostResponse>>;
  getHostStats(
    request: GetHostStatsRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetHostStatsResponse>>;
}

export interface HostsProtoClient<CallOptionsExt = {}> {
  getHosts(request: DeepPartial<GetHostsRequest>, options?: CallOptions & CallOptionsExt): Promise<GetHostsResponse>;
  register(
    request: DeepPartial<RegisterHostRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<RegisterHostResponse>;
  update(request: DeepPartial<UpdateHostRequest>, options?: CallOptions & CallOptionsExt): Promise<UpdateHostResponse>;
  getSecretKey(
    request: DeepPartial<GetSecretKeyRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetSecretKeyResponse>;
  archive(
    request: DeepPartial<ArchiveHostRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ArchiveHostResponse>;
  getHostStats(
    request: DeepPartial<GetHostStatsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetHostStatsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
